<button
  type="button"
  data-qa-tag="vessel-selector"
  aria-haspopup="dialog"
  [attr.aria-expanded]="isShowing"
  class="flex h-full cursor-pointer content-center items-center px-4 hover:bg-[#196363]"
  (click)="vesselList.toggle($event)"
  [class.bg-[#196363]]="isShowing"
>
  @let selected = this.appStore.selectedVessel();
  @if (selected) {
    <span data-qa-tag="selected-vessel-span"
      >Selected Vessel: {{ selected.name }}</span
    >
  } @else if (vesselsStore.isFetchingVessels()) {
    <span class="pr-3">Loading Vessels</span>
    <nsp-spinner class="h-8 w-8" />
  } @else {
    <span data-qa-tag="selected-vessel-span">Select a Vessel</span>
  }
</button>
<p-popover
  #vesselList
  (onShow)="onShow()"
  (onHide)="onHide()"
  styleClass="h-96 border-none! rounded-none! bg-[#1b232a]!"
>
  <re-vessel-selector-content />
</p-popover>
